export default "__VITE_ASSET__DMSkgNIF__"